import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get title(): string {
    return 'Calysta';
  }

  public get logo(): string {
    return 'assets/calysta-logo.png';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
}
